<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-07-05 14:30:50
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 11:29:38
 * svg图片
 * 在icons/index.js文件中做了Vue全局组件的注册
 -->

<template>
  <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
    <!-- <svg :class="svgClass" aria-hidden="true"> -->
    <use :xlink:href="iconName" rel="external nofollow"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName () {
      // return `#icon-${this.iconClass}`
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
